import PublishIcon from "@mui/icons-material/Publish";
import * as React from "react";
import { Button, Tooltip } from "@mui/material";
import { useProjects } from "../Behaviors/projects";
import { useStore } from "../State/zustandStore";
import {useValidation} from "../validation/validation";
import { useAsperaApi } from "../aspera/aspera";
import { CprsPopup } from "../Projects/CprsPopup";

export interface ButtonProps {
    className?: string;
    text: string;
    disabled?: boolean;
}

export const StartButton = (props: ButtonProps) => {
    const projectState = useStore((state) => state.projects);
    const projectId = projectState.selectedProjectId;
    const { project, setIsIngestRequestedAfterUpload } = useProjects(projectId!);
    const jobId = project?.jobId;
    const {hasValidationErrors, hasUnresolvedValidationRestrictions} = useValidation();
    const {uploadAll} = useAsperaApi();
    const [cprsVisible, setCprsVisible] = React.useState(false);
    const [clicked, setClicked] = React.useState(false);

    async function submit(cprsShipInfo?: string[]) {
        if (cprsShipInfo && cprsShipInfo.length > 0) {
            projectState.setSelectedCprsShipments(projectId!, cprsShipInfo);
        }

        try {
            if (project) {
                await setIsIngestRequestedAfterUpload(true);
                await uploadAll(project.projectId!) as string;
            }
        } catch (error) {
            projectState.logProjectEvent(projectId!, `Error starting ingestion ${error}`);
        } finally {
            projectState.clearProjectMessage(projectId!);
        }
    }

    async function startClick(e: React.MouseEvent<SVGSVGElement> | React.MouseEvent<HTMLButtonElement>) {
        setClicked(true);
        projectState.logProjectEvent(project?.projectId ?? "No project", "Submit job clicked");

        try {
            projectState.clearSelectedCprsShipments(projectId!);

            if (project?.cprsInformation?.length! > 0) {
                setCprsVisible(true);
            } else {
                await submit();
            }
        }
        finally {
            setClicked(false);
        }
    }

    const isDisabled = (props.disabled === true) || hasValidationErrors(jobId) || hasUnresolvedValidationRestrictions(jobId, true) || projectState.busy.has(projectId!) || clicked;

    const className = `icon-button icon-button-text ${ isDisabled ? "icon--disabled " : "" }${props.className}`;
    return <>
        <Tooltip title={props.text}>
            <Button color="primary" disableElevation={true} variant="contained" className={className} onClick={(isDisabled ? undefined : startClick)} startIcon={<PublishIcon aria-label={"Start Ingest Button"} />}>
                {props.text}
            </Button>
        </Tooltip>
        <CprsPopup
            visible={cprsVisible}
            onHide={() => setCprsVisible(false)}
            cprsInfo={project?.cprsInformation ?? []}
            onSave={async (cprsShipInfo?: string[]) => submit(cprsShipInfo)}
        />
    </>
    ;
};
